import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { EmpAllowanceComponent } from '../emp-allowance/emp-allowance.component';

@Component({
  selector: 'app-emp-allowance-list',
  templateUrl: './emp-allowance-list.component.html',
  styleUrls: ['./emp-allowance-list.component.css']
})
export class EmpAllowanceListComponent implements OnInit {

  public menu_item_id = '41';
  public add_auth;
  public edit_auth;
  public del_auth;

  private dp = [];
  displayedColumns = ['allow_name', 'allow_name_en', 'allow_perc', 'edit', 'del'];
  dataSource = new MatTableDataSource(this.dp);
  addDialogRef: MatDialogRef<EmpAllowanceComponent>;
  @ViewChild(MatSort) sort: MatSort;

  model = { 'table_name': 'emp_allowance', 'allow_name': '', 'allow_name_en': '', 'allow_perc': '' };

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog) { }

  ngOnInit() {
  }

  search() {

    let condition = "";

    if (this.model['allow_name'] != '')
      condition = " (`allow_name` LIKE '%" + this.model['allow_name'] +
        "%' OR `allow_name_en` LIKE '%" + this.model['allow_name'] + "%') AND ";
    let query = "SELECT * FROM `emp_allowance` WHERE" + condition + " `status` = '1'";
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  newAllowance() {
    this.addDialogRef = this.dialog.open(EmpAllowanceComponent, {
      hasBackdrop: false,
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['status'] == 'success')
          this.search();
      });
  }
  editAllow(row) {
    let isgoci = 0;
    if (row.is_goci == '1')
      isgoci = 1;
    let dialog_data = {
      'table_name': 'emp_allowance', 'allow_id': row.allow_id,
      'allow_name': row.allow_name,
      'allow_name_en': row.allow_name_en,
      'allow_perc': row.allow_perc,
      'is_goci': isgoci,
      'comment': row.comment
    };
    this.addDialogRef = this.dialog.open(EmpAllowanceComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        this.search();
      });
  }

  delAllow(row) {
    if (confirm("نتيجة الحذف قد تؤثر على بيانات أخرى، هل أنت متأكد من رغبتك بالاستمرار؟")) {
      let values = [{ 'table_name': this.model['table_name'], 'allow_id': row.allow_id }];
      let obj = { cmd: 'deleteRec', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(" تمت العملية بنجاح ");
            this.search();
          }
          else {
            alert(" حدث خطأ الرجاء المحاولة مرة أخرى ");
          }
        });
    }
  }
}
